import { useEffect, useState } from "react";

const KEY = "eoo_offer_ends";
const WINDOW_MS = 48 * 3600 * 1000;

const getEnd = () => {
  try {
    const saved = Number(localStorage.getItem(KEY));
    if (saved && saved > Date.now()) return saved;
  } catch {}
  const t = Date.now() + WINDOW_MS;
  try {
    localStorage.setItem(KEY, String(t));
  } catch {}
  return t;
};

const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ className = "" }) => {
  const [end] = useState(getEnd);
  const [left, setLeft] = useState(() => Math.max(0, end - Date.now()));

  useEffect(() => {
    const t = setInterval(() => setLeft(Math.max(0, end - Date.now())), 1000);
    return () => clearInterval(t);
  }, [end]);

  const totalSec = Math.floor(left / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;

  return (
    <div data-testid="offer-countdown" className={`flex items-center gap-2 ${className}`}>
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#F59E0B] opacity-60" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-[#F59E0B]" />
      </span>
      <p className="font-mono-alt text-[11px] sm:text-xs uppercase tracking-[0.25em] text-[#FCD34D]">
        Early-reader offer ends in{" "}
        <span className="text-[#F8FAFC] tabular-nums" data-testid="offer-countdown-timer">
          {pad(h)}:{pad(m)}:{pad(s)}
        </span>
      </p>
    </div>
  );
};

export default Countdown;
